import { v5 as uuidv5, v4 as uuidv4 } from 'uuid';

const NAMESPACE = '872136a0-367b-488a-a281-c2814e8195d2'; // Random generated namespace
export const UUIDGenerator = {
  title: 'deviceId',
  DEFAULT_DEVICE_ID: '00000000-0000-4000-0000-00000000',

  get quarters() {
    const date = new Date();
    return [0, 6, 12, 18].map(hour => date.setHours(hour, 0, 0, 0));
  },

  get currentQuarter() {
    const curTime = Date.now();
    return this.quarters.reverse().find(quarter => quarter <= curTime);
  },

  // https://support.google.com/admanager/answer/10678356?hl=en#sid
  sessionId(deviceID?: string) {
    // Returning 0 as string if no deviceID, as this for admanager means "optout"
    if (!deviceID || deviceID === '') return '0';
    return uuidv5(this.currentQuarter + deviceID, NAMESPACE);
  },

  deviceId() {
    let deviceId = localStorage.getItem(this.title);
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(this.title, deviceId);
    }

    return deviceId;
  },

  formatAsUUID(deviceId: string) {
    if (deviceId.length !== 32) return this.DEFAULT_DEVICE_ID;
    return deviceId.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
  },
};
